module.exports = __webpack_public_path__ + "static/target-117b05a4b74fe3e9d4badbdec02055b8.png";